module.exports = __webpack_public_path__ + "static/klimaatbestendig-stad-zwolle-senshagen-wijk-313c5dbc686ec0d1502182abe75c58d8.jpg";